import { TranslationType } from '../components/HbtMasterPoolTable/types';

export const requestTypeMapping = (t: TranslationType) => {
  const mapping = {
    '0': t('Pi-Portfolio-Management-Table-RequestType-Mapping-NP', 'New Portfolio'),
    '1': t('Pi-Portfolio-Management-Table-RequestType-Mapping-Repl', 'Replacement')
  };
  return mapping;
};
